import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";

import { ManufacturerActions } from "redux/actions/settings/ManufacturerActions";
import { ManufacturerTypeActions } from "redux/actions/settings/ManufacturerTypeActions";
import { ModalActions } from "redux/actions/ModalActions";
import { StoreModel } from "models/StoreModel";
import { LoginUser } from "models/LoginUser";
import { Manufacturer } from "models/Manufacturer";
import { ManufacturerType } from "models/ManufacturerType";
import { TableColumn, Table, TableRow } from "app/components/common/Table";
import { PageContentHeader } from "app/components/common/PageContentHeader";
import { Translations } from "models/Translations";
import { Translate } from "infrastructure/mapping/Translate";
import Translator from "app/components/common/Translator";

interface Props {
    fetchManufacturers: typeof ManufacturerActions.fetchManufacturers;
    fetchManufacturerTypes: typeof ManufacturerTypeActions.fetchManufacturerTypes;
    addManufacturerForm: typeof ModalActions.showModal;
    addManufacturer: typeof ManufacturerActions.addManufacturer;
    editManufacturerForm: typeof ModalActions.showModal;
    editManufacturer: typeof ManufacturerActions.editManufacturer;
    deleteManufacturer: typeof ManufacturerActions.deleteManufacturer
    loginUser: LoginUser;
    manufacturers: Manufacturer[];
    manufacturerTypes: ManufacturerType[];
    translations: Translations;
}

class ManufacturersComp extends React.Component<Props> {

    componentDidMount() {
        if (this.loggedIn()) {
            if (!this.props.manufacturers)
                this.props.fetchManufacturers(this.props.loginUser.token);
            if (!this.props.manufacturerTypes)
                this.props.fetchManufacturerTypes(this.props.loginUser.token);
        }
    }

    loggedIn() {
        return this.props.loginUser && this.props.loginUser.token;
    }

    ready() {
        return this.loggedIn() && this.props.manufacturers && this.props.manufacturerTypes
    }

    setTableData(): TableRow[] {
        let data: TableRow[] = [];
        {
            this.props.manufacturers.forEach(manufacturer => {
                data.push({
                    dataObject: {
                        id: manufacturer.id,
                        name: manufacturer.name,
                        manufacturerType: manufacturer.manufacturerType && { ...manufacturer.manufacturerType, name: Translate.text(this.props.translations, manufacturer.manufacturerType.name) },
                        archivedDate: manufacturer.archivedDate
                    }
                })
            })
        }
        return data;
    }

    setColumns(): TableColumn[] {
        // TODO maybe dynamic??
        return [
            {
                header: 'Id',
                accessor: 'id',
            },
            {
                header: 'Manufacturer',
                accessor: 'name',
            },
            {
                header: 'Type',
                accessor: 'manufacturerType',
            }
        ];
    }

    render() {
        if (!this.ready()) {
            return (
                <div className="c-page__content">
                    <PageContentHeader text="Manufacturer" />
                    <Translator text="Loading" />
                </div>
            )
        }
        return (
            <div className="c-page__content">
                <PageContentHeader text="Manufacturer" />
                <div className="c-card">
                    <Table
                        addAction={this.props.addManufacturer}
                        addFormAction={this.props.addManufacturerForm}
                        addFormData={{
                            header: "Add a new Manufacturer",
                            formObject: Manufacturer.empty(),
                        }}
                        editAction={this.props.editManufacturer}
                        editFormAction={this.props.editManufacturerForm}
                        editFormData={{
                            header: "Edit Manufacturer",
                        }}
                        deleteAction={this.props.deleteManufacturer}
                        editable={true}
                        columns={this.setColumns()}
                        tableData={this.setTableData()}
                        translations={this.props.translations}
                        loginUser={this.props.loginUser}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: StoreModel) {
    return {
        loginUser: state.loginUser,
        manufacturers: state.manufacturers,
        manufacturerTypes: state.manufacturerTypes,
        translations: state.translations
    };
}
function mapDispatchToProps(dispatch: Dispatch) {
    return {
        fetchManufacturers: bindActionCreators(ManufacturerActions.fetchManufacturers, dispatch),
        fetchManufacturerTypes: bindActionCreators(ManufacturerTypeActions.fetchManufacturerTypes, dispatch),
        addManufacturer: bindActionCreators(ManufacturerActions.addManufacturer, dispatch),
        addManufacturerForm: bindActionCreators(ModalActions.showModal, dispatch),
        editManufacturer: bindActionCreators(ManufacturerActions.editManufacturer, dispatch),
        editManufacturerForm: bindActionCreators(ModalActions.showModal, dispatch),
        deleteManufacturer: bindActionCreators(ManufacturerActions.deleteManufacturer, dispatch),
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ManufacturersComp);